import apiClient from '../client';
import type {
  HealthPlanDto,
  PatientHealthPlanDto,
  CreatePatientHealthPlanRequest,
  UpdatePatientHealthPlanRequest,
} from '@/types/healthplan.types';

export const healthPlansApi = {
  // Health Plans
  getAll: async (activeOnly = false): Promise<HealthPlanDto[]> => {
    const response = await apiClient.get<HealthPlanDto[]>('/v1/health-plans', {
      params: { activeOnly },
    });
    return response.data;
  },

  getById: async (id: string): Promise<HealthPlanDto> => {
    const response = await apiClient.get<HealthPlanDto>(`/v1/health-plans/${id}`);
    return response.data;
  },

  getByCode: async (code: string): Promise<HealthPlanDto> => {
    const response = await apiClient.get<HealthPlanDto>(`/v1/health-plans/code/${code}`);
    return response.data;
  },

  // Patient Health Plans (Carteirinhas)
  getPatientHealthPlans: async (patientId: string): Promise<PatientHealthPlanDto[]> => {
    const response = await apiClient.get<PatientHealthPlanDto[]>(
      `/v1/health-plans/patient/${patientId}`
    );
    return response.data;
  },

  getPatientPrimaryHealthPlan: async (patientId: string): Promise<PatientHealthPlanDto | null> => {
    try {
      const response = await apiClient.get<PatientHealthPlanDto>(
        `/v1/health-plans/patient/${patientId}/primary`
      );
      return response.data;
    } catch {
      return null;
    }
  },

  getByCardNumber: async (cardNumber: string): Promise<PatientHealthPlanDto> => {
    const response = await apiClient.get<PatientHealthPlanDto>(
      `/v1/health-plans/card/${cardNumber}`
    );
    return response.data;
  },

  addHealthPlanToPatient: async (
    request: CreatePatientHealthPlanRequest
  ): Promise<PatientHealthPlanDto> => {
    const response = await apiClient.post<PatientHealthPlanDto>(
      '/v1/health-plans/patient',
      request
    );
    return response.data;
  },

  removeHealthPlanFromPatient: async (patientHealthPlanId: string): Promise<void> => {
    await apiClient.delete(`/v1/health-plans/patient/${patientHealthPlanId}`);
  },

  setPrimaryHealthPlan: async (patientHealthPlanId: string): Promise<PatientHealthPlanDto> => {
    const response = await apiClient.patch<PatientHealthPlanDto>(
      `/v1/health-plans/patient/${patientHealthPlanId}/primary`
    );
    return response.data;
  },

  updatePatientHealthPlan: async (
    patientHealthPlanId: string,
    request: UpdatePatientHealthPlanRequest
  ): Promise<PatientHealthPlanDto> => {
    const response = await apiClient.put<PatientHealthPlanDto>(
      `/v1/health-plans/patient/${patientHealthPlanId}`,
      request
    );
    return response.data;
  },
};
